<template>
  <InnerCardInfo
    :label="localStorage.translations.pages.finance.pages.salary"
    :data="[
      {
        name: translation['salary_hourly'],
        value: $formatCurrency(data.salary) + ' ' + translation['euro_hour'] || '- ' + translation['euro_hour'],
      },
      {
        name: translation['personal_premium'],
        value: $formatCurrency(data.premium) + ' ' + translation['euro_hour'] || '- ' + translation['euro_hour'],
      },
    ]"
    :to="to"
    ref="inner"
    button-icon="show"
    :editReady="editReady"
  >
    <template slot="edit_block">
      <slot />
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo.vue'

export default {
  name: 'SalaryPdf',
  components: { InnerCardInfo },
  props: {
    to: {
      type: [String, Object],
      default: null,
    },
    data: {
      type: Object,
      default: () => {
        return {
          salary: '-',
          premium: '-',
        }
      }
    },
    editReady: Boolean,
  },
  computed: {
    translation() {
      return this.localStorage.translations.pages['setting-personal_area'].labels
    },
  },
}
</script>

<style scoped></style>